import { useState, useCallback } from 'react';
import isDataURL from '@utils/isDataURL';

const determineIfElementMatches = (element, selector) => {
  return element.matches(selector);
};

const checkPreviewBoundary = (target) => {
  let element = target;

  do {
    if (determineIfElementMatches(element, '[data-image-preview]')) {
      return true;
    }

    if (determineIfElementMatches(element, '[data-image-preview-boundary]')) {
      return false;
    }

    element = element.parentNode;
  } while (element);

  return false;
};

const useCaptureImageClicked = () => {
  const [previewURL, setPreviewURL] = useState(null);

  const clearPreviewURL = useCallback(() => {
    setPreviewURL(null);
  }, []);

  const handleOnClick = useCallback((event) => {
    if (event.target.nodeName !== 'IMG') {
      return;
    }

    const src = event.target.getAttribute('src');

    if (src && !event.target.getAttribute('data-latex')) {
      const isWithinBoundary = checkPreviewBoundary(event.target);

      if (!isWithinBoundary) {
        return;
      }

      event.stopPropagation();

      const url = new URL(src);

      if (!isDataURL(src)) {
        url.searchParams.set('w', '640');
      }

      setPreviewURL(url.toString());
    }
  }, []);

  return {
    previewURL,
    clearPreviewURL,
    handleOnClick
  };
};

export default useCaptureImageClicked;
